import { useTranslation } from 'react-i18next'

import { ResultSection } from 'aem-libs-react-components/src/components/calculators/components/result-section'
import { formatShortDate } from 'aem-libs-ts/src/utils/formatting/dates/formatShortDate'

import { testIds } from '../e2e/testIds'
import { useAccountNumberForLoanError } from '../hooks/useAccountNumberForLoanError'
import { useFeeQuery } from '../hooks/useFeeQuery'
import { earlyRepaymentStore } from '../store'

export const ResultBoard = () => {
  const { t } = useTranslation()
  const inputValues = earlyRepaymentStore.useStoreData()
  const { response, isFetching, error } = useFeeQuery()
  const { getErrorDescription } = useAccountNumberForLoanError()

  return (
    <ResultSection.Container loading={isFetching}>
      {!response && (
        <ResultSection.CenteredRow height={100}>
          <ResultSection.ValueText>
            {error ? getErrorDescription(error?.data.errors[0]?.errorDescription ?? '') : t('NO_RESULT')}
          </ResultSection.ValueText>
        </ResultSection.CenteredRow>
      )}
      {response && (
        <>
          <ResultSection.CenteredRow height={100}>
            {t('RESULT_LABEL')}
            <ResultSection.AnimatedValue
              ariaLabel={t('RESULT_LABEL')}
              value={Math.round(response.fee.value ?? 0)}
              unitType={'czk'}
            />
            <div data-testid={testIds.resultDate}>
              {t('RESULT_DATE_INFO', { date: formatShortDate(new Date(inputValues.date ?? '')) })}{' '}
            </div>
            {t('RESULT_INFO')}
          </ResultSection.CenteredRow>
        </>
      )}
    </ResultSection.Container>
  )
}
